<template>
  <v-container fluid style="max-width: 1280px;">
    <v-layout alig-start>
      <v-flex>
        <!-- Inicio de barra de alerta -->
        <v-snackbar v-model="alerta.snackbar" :color="alerta.color" @click="alerta.snackbar = false">{{ alerta.text }}
        </v-snackbar>
        <!-- Fin inicio de barra de alerta -->

        <!-- <div id="contenedor"></div> -->
        <div id="contenedor" style="position: absolute; visibility: hidden;"></div>
        <v-data-table :loading="loading" :headers="fvehiculo == false ? asignacionesMobiliario : asignacionesVehiculo"
          :items="reporteAsignacion" :items-per-page="15" class="elevation-3" dense>
          <template v-slot:top>
            <v-form v-model="isValid">
              <v-toolbar flat>
                <!-- Formulario busqueda de bienes activos -->
                <v-toolbar-title class="hidden-sm-and-down">ASIGNACIONES</v-toolbar-title>
                <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>

                <!-- Formulario busqueda de asignacion -->
                <v-autocomplete dense @keyup="selectAsignacion()" :search-input.sync="buscar_personal"
                  v-model.trim="idasignacion" :items="selectAsignacionArray"
                  label="Selecciona: Personal | Local > Area - Oficina" :rules="[v => !!v || 'Requerido']"
                  @change="reporteAsignacion = [], listar(), detalleAsignacion(idasignacion)"
                  @click:prepend="mostrarFiltro()" prepend-icon="filter_list" clearable hide-details class="mr-1">
                </v-autocomplete>
                <!-- Fin Formulario busqueda de asignacion -->
                <!-- Impresion asignacion -->
                <!--  <v-btn text fab x-small :loading="desabilitar" :disabled="desabilitar || !isValid" color="accent"
                  @click="mostrarAsignacionImp()" class="mr-1">
                  <v-icon>print</v-icon>
                </v-btn> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small icon :loading="desabilitar" :disabled="desabilitar || !isValid"
                      color="accent" @click="mostrarAsignacionImp()" class="mr-1" v-bind="attrs" v-on="on">
                      <v-icon>assignment</v-icon>
                    </v-btn>
                  </template>
                  <span>Ficha Asignación de Uso</span>
                </v-tooltip>
                <!-- <v-btn text fab x-small :loading="desabilitar" :disabled="desabilitar || !isValid" color="accent"
                  @click="mostrarAsignacionInventImp()" class="mr-1" v-if="usuarioState.seguimientoinv == 'SI'">
                  <v-icon>assignment</v-icon>
                </v-btn> -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small icon :loading="desabilitar" :disabled="desabilitar || !isValid"
                      color="accent" @click="mostrarAsignacionInventImp()" class="mr-1"
                      v-if="usuarioState.seguimientoinv == 'SI'" v-bind="attrs" v-on="on">
                      <v-icon>assignment</v-icon>
                    </v-btn>
                  </template>
                  <span>Ficha Levantamiento de Información</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small :loading="desabilitar" :disabled="desabilitar || !isValid" color="accent"
                      @click="mostrarAsignacionImpBarcode()" class="mr-1" v-bind="attrs" v-on="on">
                      <v-icon>qr_code</v-icon>
                    </v-btn>
                  </template>
                  <span>Códigos de Barra</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn text fab x-small color="success" @click="crearXLSX()" :loading="desabilitar"
                      :disabled="desabilitar || !isValid" v-bind="attrs" v-on="on">
                      <v-icon>summarize</v-icon>
                    </v-btn>
                  </template>
                  <span>Reporte Excel</span>
                </v-tooltip>
              </v-toolbar>
            </v-form>
          </template>
          <!-- Formatear detalle -->
          <template v-slot:item.codbien="{ item }">
            <template v-if='item.codbien.length == 12'>
              <v-chip small label color="primary">
                <span style="padding: 0; margin: 0;">
                  {{ item.codbien.substr(0, 8) }}<strong>{{ item.codbien.substr(8, 12) }}</strong>
                </span>
              </v-chip>
            </template>
            <template v-else-if="item.codbien.length == 8">
              <v-chip small label color="internal" text-color="white">
                <span>{{ item.codbienint + "-" + item.codinterno }}</span>
              </v-chip>
            </template>
          </template>

          <template v-slot:item.situacion="{ item }">
            <template>
              <span v-for="items in cm.flg_situaciones" text v-if="items.value == item.situacion">{{ items.text
              }}</span>
            </template>
          </template>
          <template v-slot:item.flg_estado="{ item }">
            <template>
              <span v-for="items in cm.flg_estados" text v-if="items.value == item.flg_estado">{{ items.text }}</span>
            </template>
          </template>
          <template v-slot:item.fec_act="{ item }">
            <span>{{ item.fec_act | formatearFechaHora }}</span>
          </template>
          <!-- Fin Formatear detalle -->
        </v-data-table>

        <!-- Mostrar impresion Modal bien -->
        <v-dialog v-model="verAsignacionModal" max-width="800px" scrollable persistent>
          <v-card>
            <v-toolbar dark dense class="primary">
              <v-toolbar-title>Asignación de Bien Patrimonial</v-toolbar-title>
              <v-spacer />
              <span>{{ codbien }}</span>
              <v-spacer />
              <v-btn icon dark class="hidden-sm-and-down" @click="printExternal()">
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn icon dark @click="savePdf()">
                <v-icon>download</v-icon>
              </v-btn>
              <v-btn icon dark @click="ocultarAsignacion()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 450px;" class="px-0">
              <pdf v-for="i in numPages" :key="i" :src="srcPdf" :page="i"></pdf>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar impresion Modal bien -->

        <!-- Mostrar Filtro -->
        <v-dialog v-model="verFiltroModal" max-width="260px">
          <v-card>
            <v-toolbar dark dense class="primary">
              <v-toolbar-title>Filtro</v-toolbar-title>
              <v-spacer />
              <v-btn icon dark @click="limpiarFiltro()" :disabled="desabilitar || !isValid">
                <v-icon>clear_all</v-icon>
              </v-btn>
              <v-btn icon dark @click="ocultarFiltro()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-menu v-model="menuFecha" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field dense v-model="dateRangeText" :disabled="desabilitar || !isValid" readonly v-on="on"
                    label="Fecha Actualizado" hide-details class="mr-1 mt-5">
                  </v-text-field>
                </template>
                <v-date-picker v-model="dates" @input="dates.length == 1 ? menuFecha = true : menuFecha = false"
                  @change="listar()" range>
                </v-date-picker>
              </v-menu>
              <v-checkbox color="internal" v-model="finterno" label="Cód. Interno" :disabled="desabilitar || !isValid"
                @click="listar" dense hide-details></v-checkbox>
              <v-checkbox v-model="fvehiculo" label="Vehiculos" :disabled="desabilitar || !isValid" @click="listar"
                dense hide-details></v-checkbox>
              <v-checkbox color="error" v-model="ffaltante" label="Faltantes" :disabled="desabilitar || !isValid"
                @click="listar" dense hide-details></v-checkbox>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Fin Mostrar Filtro -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import { mapState } from "vuex"; //Importamos para llamar a los elementos
import moment from "moment";
import pdf from "vue-pdf"; // Visor de pdf
import Barcode from "jsbarcode";
import ExcelJS from 'exceljs';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      reporteAsignacion: [],
      dialog: false,
      asignacionesMobiliario: [
        { text: "C.Patrimonial", value: "codbien", sortable: false, width: 135 },
        { text: "Tipo de Bien", value: "tbdescripcion", sortable: false },
        { text: "Marca", value: "marca", sortable: false },
        { text: "Modelo", value: "modelo", sortable: false },
        { text: "Tipo", value: "tipo", sortable: false },
        { text: "Color", value: "color", sortable: false },
        { text: "SITUACIÓN", value: "situacion", sortable: false },
        { text: "Estado", value: "flg_estado", sortable: false },
        { text: "Usuario", value: "nickname", sortable: false },
        { text: "Fec. Actualizado", value: "fec_act", sortable: false },
      ],
      asignacionesVehiculo: [
        { text: "C.PATRIMONIAL", value: "codbien", sortable: false, width: 135 },
        { text: "Tipo de Bien", value: "tbdescripcion", sortable: false },
        { text: "Marca", value: "marca", sortable: false },
        { text: "Modelo", value: "modelo", sortable: false },
        { text: "Placa", value: "placa", sortable: false },
        { text: "Chasis/Serie", value: "numchasis", sortable: false },
        { text: "Motor", value: "nummotor", sortable: false },
        { text: "Año", value: "ano", sortable: false },
        { text: "SITUACIÓN", value: "situacion", sortable: false },
        { text: "Estado", value: "flg_estado", sortable: false },
        { text: "Usuario", value: "nickname", sortable: false },
        { text: "Fec. Actualizado", value: "fec_act", sortable: false },
      ],
      desabilitar: false,
      isValid: true,
      loading: false,
      alerta: { snackbar: false, color: "", text: "" },

      codbien: "",
      nompersonal: "",
      nrodocpersonal: "",
      nomlocal: "",
      nomarea: "",
      nomoficina: "",
      direclocal: "",

      idasignacion: "", // selectAsignacionArray

      selectAsignacionArray: [],
      buscar_personal: "",

      stringPdf: "",
      srcPdf: "",
      blobPdf: "",
      numPages: undefined,
      verAsignacionModal: 0,
      verFiltroModal: 0,

      dates: [
        moment("2000-01-01").format("YYYY-MM-DD"),
        moment().endOf("day").format("YYYY-MM-DD"),
      ],
      menuFecha: false,

      fechaActual: moment().startOf("day").format("YYYY-MM-DD"),

      ffaltante: false,
      fvehiculo: false,
      finterno: false
    };
  },

  computed: {
    ...mapState(["usuarioState", "empresaState"]), // Llamamos a state

    dateRangeText() {
      let fechaIni;
      let fechaFin;
      for (var i = 0; i < this.dates.length; i++) {
        fechaIni = this.formatFecha(this.dates[0]);
        fechaFin = this.formatFecha(this.dates[1]);
      }
      let arrayFechas = [fechaIni, fechaFin];
      return arrayFechas.join(" ~ ");
    },
  },

  created() {
    this.selectAsignacion();
  },

  methods: {
    formatFecha(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    // Para descargar pdf de blob
    savePdf() {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(this.blobPdf);
      var fileName = "Ficha de bienes asignados";
      link.download = fileName;
      link.click();
    },

    // Llamamos de main.js printJS
    printExternal() {
      printJS({
        printable: this.stringPdf.replace("data:application/pdf;filename=generated.pdf;base64,", ""),
        type: "pdf",
        base64: true,
      });
    },

    /* Listar bienes activos */
    listar() {
      let me = this;
      me.desabilitar = true;
      me.loading = true;

      axios
        .get("api/Bienes/ListarAsignacionBienFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            idasignacion: me.idasignacion,
            ffaltante: me.ffaltante,
            fvehiculo: me.fvehiculo,
            finterno: me.finterno,
            fechainicio: me.dates[0],
            fechafin: me.dates[1] == undefined ? me.dates[0] + " 23:59:59" : me.dates[1] + " 23:59:59",
          },
        })
        .then(function (response) {
          me.reporteAsignacion = response.data;
          me.desabilitar = false;
          me.loading = false;
          //console.log(me.reporteAsignacion);
        })
        .catch((err) => {
          me.desabilitar = false;
          me.loading = false;
          me.alerta.snackbar = true;
          me.alerta.color = "error";
          me.alerta.text = "Ocurrio un error";
          //console.log(err.response);
        });
    },
    /* Fin Listar bienes activos */

    // Seleccionar motivos
    detalleAsignacion(valor) {
      let me = this;
      if (valor != null) {
        const selectId = me.selectAsignacionArray.find(
          (elemento) => elemento.value === valor
        );
        me.nompersonal = selectId.nom;
        me.nrodocpersonal = selectId.nrodoc;
        me.nomlocal = selectId.local;
        me.nomarea = selectId.area;
        me.nomoficina = selectId.oficina;
        me.direclocal = selectId.direccion;
      }
    },

    /*     selectAsignacion() {
          let me = this;
          var asignacionArray = [];
    
          // Select asignacion para area de la asignacion
          axios
            .get("api/Asignaciones/SelectAsignacionFiltro", {
              params: {
                idempresa: me.usuarioState.idempresa,
                buscar: me.buscar_personal == "" ? "-" : me.buscar_personal == null ? "-" : me.buscar_personal,
              },
            })
    
            .then(function (response) {
              asignacionArray = response.data;
              asignacionArray.map(function (x) {
                me.selectAsignacionArray.push({
                  text: x.nompersonal + " | " + x.nomlocal + " > " + x.nomarea + " - " + x.nomoficina + " [" + x.cantbienes + "]",
                  nom: x.nompersonal,
                  nrodoc: x.nrodocpersonal,
                  local: x.nomlocal,
                  area: x.nomarea,
                  oficina: x.nomoficina,
                  direccion: x.direclocal,
                  value: x.idasignacion,
                });
              });
            })
            .catch((err) => {
              //console.log(err.response);
            });
        }, */

    selectAsignacion() {
      let me = this;

      axios
        .get("api/Asignaciones/SelectAsignacionFiltro", {
          params: {
            idempresa: me.usuarioState.idempresa,
            buscar: me.buscar_personal == "" ? "-" : me.buscar_personal == null ? "-" : me.buscar_personal,
          },
        })
        .then(function (response) {

          me.selectAsignacionArray = response.data.map(x => ({
            text: x.nompersonal + " | " + x.nomlocal + " > " + x.nomarea + " - " + x.nomoficina + " [" + x.cantbien + "]",
            nom: x.nompersonal,
            nrodoc: x.nrodocpersonal,
            local: x.nomlocal,
            area: x.nomarea,
            oficina: x.nomoficina,
            direccion: x.direclocal,
            value: x.idasignacion,
          }));

        })
        .catch((err) => { });
    },

    ocultarAsignacion() {
      this.verAsignacionModal = 0;
      this.stringPdf = "";
      this.blobPdf = "";
      this.numPages = undefined;
      document.getElementById("contenedor").innerHTML = ""; // Limpiamos comtenedor de codigo de barras
    },

    mostrarAsignacionImp() {
      this.verAsignacionModal = 1;
      this.crearPDF();
    },

    mostrarAsignacionInventImp() {
      this.verAsignacionModal = 1;
      this.crearPDFInvent();
    },

    mostrarAsignacionImpBarcode() {
      this.verAsignacionModal = 1;
      this.crearBarcode();
    },

    mostrarFiltro() {
      this.verFiltroModal = 1;
    },

    ocultarFiltro() {
      this.verFiltroModal = 0;
    },

    limpiarFiltro() {
      this.dates = [
        moment("2000-01-01").format("YYYY-MM-DD"),
        moment().endOf("day").format("YYYY-MM-DD"),
      ],
        this.dateRangeText,
        this.ffaltante = false,
        this.fvehiculo = false,
        this.finterno = false,
        this.listar()
    },

    /* Crear PDF Codigo de barras */
    async crearBarcode() {
      let me = this;
      const contenedor = document.querySelector("#contenedor");

      // Por cada producto, crear un SVG y adjuntarlo
      me.reporteAsignacion.forEach((producto) => {
        const elemento = document.createElement("img");
        //elemento.dataset.format = "CODE39";
        elemento.dataset.value = producto.codbien;
        elemento.dataset.text = producto.tbdescripcion;
        elemento.classList.add("codbien");
        contenedor.appendChild(elemento);
      });

      Barcode(".codbien")
        .options({
          format: "CODE39", // El formato
          width: 3, // La anchura de cada barra
          height: 100, // La altura del código
          displayValue: false,
          marginTop: 10, // Margen superior
          marginRight: 10, // Margen derecho
          marginBottom: 10, // Margen inferior
          marginLeft: 10, // Margen izquierdo
        })
        .init();

      const nodeMap = await document.getElementById("contenedor").childNodes;

      var arrayBien = [];
      var item = 0;
      for (let i = 0; i < nodeMap.length; i++) {
        arrayBien.push({
          img: nodeMap[i].currentSrc,
          codbien: nodeMap[i].dataset.value,
          descripcion: nodeMap[i].dataset.text,
          item: item + i,
        });
      }

      var doc = new jsPDF("l", "mm", [55, 30]);

      const logo = me.empresaState.logo;
      const medio = doc.internal.pageSize.width / 2;
      const mensaje = "No tocar ni despegar el stickers que identifica el bien del estado";
      const comision = me.empresaState.detalle_inv;
      const ano = me.empresaState.ano_inv;

      arrayBien.forEach((producto, i) => {
        if (i > 0) doc.addPage(); // solo agregar página a partir del segundo producto

        // Titulo
        doc.setFontSize(5);
        doc.setFont("helvetica", "bold");
        //doc.text(me.empresaState.nombre.substr(0, 48), medio, 6, { align: "center" });
        doc.text(me.empresaState.nombre, medio + 3, 5.5, { align: "center", maxWidth: 45 });
        // Logo
        doc.addImage(logo, "PNG", 3, 3, 4, 5);
        // Imagen Codigo Barra
        doc.addImage(arrayBien[i].img, "PNG", 4, 8, 48, 8);
        // Codigo Bien
        doc.setFontSize(9);
        doc.text(arrayBien[i].codbien, medio, 18.5, { align: "center" });
        // Comision
        doc.setFontSize(5);
        doc.text(comision + " " + ano, 4, 21);
        // Descripcion Bien
        doc.setFontSize(4);
        doc.text(arrayBien[i].descripcion.substr(0, 55), 4, 23);
        // Mensaje
        doc.line(4, 24, 52, 24);
        doc.text(mensaje, medio, 26, { align: "center" });
      });

      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");
      // Para visualizar todas las paginas del pdf
      this.srcPdf = pdf.createLoadingTask(this.stringPdf);
      this.srcPdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });

      //console.log(bcBien);
    },
    /* Fin Crear PDF Codigo de barras */

    /* Crear PDF asignacion */
    crearPDF() {
      let me = this;

      var columns = [
        { header: "Nº", dataKey: "item" },
        { header: "C.PATRIMONIAL", dataKey: "codbien" },
        { header: "DENOMINACIÓN", dataKey: "tbdescripcion" },
        { header: "MARCA", dataKey: "marca" },
        { header: "MODELO", dataKey: "modelo" },
        //{ header: "TIPO", dataKey: "tipo" },
        { header: "COLOR", dataKey: "color" },
        { header: "SERIE", dataKey: "serie" },
        { header: "OTROS", dataKey: "otras_caract" },
        //{ header: "DIMENSION", dataKey: "dimension" },
        { header: "ESTADO", dataKey: "estado" },
        { header: "OBSERVACIONES", dataKey: "observacion" },
      ];
      var body = [];

      for (var i = 0; i < me.reporteAsignacion.length; i++) {
        var f_estado = "";
        for (var e = 0; e < me.cm.flg_estados.length; e++) {
          f_estado = f_estado + (me.reporteAsignacion[i].flg_estado == me.cm.flg_estados[e].value ? me.cm.flg_estados[e].text : "");
        }

        body.push({
          item: i + 1,
          codbien: me.reporteAsignacion[i].codbien.length == 12 ? me.reporteAsignacion[i].codbien : me.reporteAsignacion[i].codbienint + "-" + me.reporteAsignacion[i].codinterno,
          tbdescripcion: me.reporteAsignacion[i].tbdescripcion,
          marca: me.reporteAsignacion[i].marca,
          modelo: me.reporteAsignacion[i].modelo,
          //tipo: me.reporteAsignacion[i].tipo,
          color: me.reporteAsignacion[i].color,
          serie: me.reporteAsignacion[i].serie,
          otras_caract: me.reporteAsignacion[i].otras_caract,
          //dimension: me.reporteAsignacion[i].dimension,
          estado: f_estado,
          observacion: me.reporteAsignacion[i].observacion,
        });
      }

      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        for (i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(imgData, "JPEG", 20, 10, 11, 14); // Logo
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("FICHA DE ASIGNACION EN USO Y DEVOLUCIÓN DE BIENES MUEBLES PATRIMONIALES", doc.internal.pageSize.width / 2, 15, { align: "center" });
          // doc.text(
          //   "Mobiliario, Equipo y Maquinaria",
          //   doc.internal.pageSize.width / 2,
          //   15,
          //   {
          //     align: "center",
          //   }
          // );
          doc.setFontSize(10);
          doc.text(me.empresaState.nombre, doc.internal.pageSize.width / 2, 19, { align: "center" });
          doc.text("DATOS DEL USUARIO", 40, 25);
          if (me.ffaltante) { doc.text("BIENES FALTANTES", 250, 25); }
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text("Nombres y apellidos: " + me.nompersonal, 40, 30);
          doc.text("Nº DNI: " + me.nrodocpersonal, 160, 30);
          doc.text("Correo electrónico: ", 40, 35);
          doc.text("Local: " + me.nomlocal, 40, 40);
          doc.text("Area: " + me.nomarea, 40, 45);
          doc.text("Oficina: " + me.nomoficina, 160, 45);
          doc.text("Dirección: " + me.direclocal, 40, 50);
          doc.setFontSize(6);
          doc.text("Pag. " + i + " de " + pageCount, 250, 13);
          doc.setFont("helvetica", "bold");
          doc.text("Fecha: " + me.formatFecha(me.fechaActual) + "  Ref. " + me.idasignacion, 250, 17);
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        for (i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setDrawColor(0, 0, 0);
          //doc.setLineWidth(0.5)
          var pageWidth = doc.internal.pageSize.width; // Ancho de la hoja
          // Firmas
          var line = 196;
          var linlong = 50;
          var linMargin = 20;

          var startL1 = (pageWidth - linlong * 3 - linMargin * 2) / 2;
          var startL2 = startL1 + linlong + linMargin;
          var startL3 = startL2 + linlong + linMargin;

          doc.line(startL1, line, startL1 + linlong, line);
          doc.text(startL1 + 20, 200, "Usuario");

          doc.line(startL2, line, startL2 + linlong, line);
          doc.text(startL2 + 13, 200, "Personal de la OCP");

          doc.line(startL3, line, startL3 + linlong, line);
          doc.text(startL3 + 13, 200, "Registro SIME OCP");

          // Consideraciones
          doc.setFont("helvetica", "bold");
          doc.text(10, 170, "CONSIDERACIONES:");
          doc.setFont("helvetica", "normal");
          doc.text(15, 175, "- El usuario es responsable de la permanencia y conservación de cada uno de los bienes descritos, recomendánse tomar las precaciones del caso para evitar sustracciones, deterioros, etc.");
          doc.text(15, 180, "- Cualquier necesidad de traslado del bien mueble patrimonial dentro o fuera del local de la Entidad u Organizacion de la Entidad, es previamente comunicado al encargado de la OCP.");
        }
      };

      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("l", "mm");

      doc.autoTable({
        theme: "grid",
        columns,
        body,
        margin: { top: 53, bottom: 45, left: 10, right: 10 },
        styles: { cellPadding: 1, overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 79, 120],
          fontSize: 6,
          halign: "center",
          fontStyle: "bold",
        },
        bodyStyles: { textColor: 0, fontSize: 6 },
        columnStyles: {
          item: { cellWidth: 8, halign: "center" },
          codbien: { cellWidth: 20, halign: "center" },
          tbdescripcion: { cellWidth: 44 },
          marca: { cellWidth: 35 },
          modelo: { cellWidth: 30 },
          //tipo: { cellWidth: 28 },
          color: { cellWidth: 28 },
          serie: { cellWidth: 28 },
          otras_caract: { cellWidth: 33 },
          //dimension: { cellWidth: 28 },
          estado: { cellWidth: 16 },
          observacion: { cellWidth: 35 },
        },
      });
      // 515.28 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");

      // Para visualizar todas las paginas del pdf
      this.srcPdf = pdf.createLoadingTask(this.stringPdf);
      this.srcPdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
    /* Crear PDF asignacion */

    /* Crear PDF asignacion */
    crearPDFInvent() {
      let me = this;

      var columns = [
        { header: "Nº", dataKey: "item" },
        { header: "C.PATRIMONIAL", dataKey: "codbien" },
        { header: "DENOMINACIÓN", dataKey: "tbdescripcion" },
        { header: "MARCA", dataKey: "marca" },
        { header: "MODELO", dataKey: "modelo" },
        { header: "TIPO", dataKey: "tipo" },
        { header: "COLOR", dataKey: "color" },
        { header: "SERIE", dataKey: "serie" },
        { header: "DIMENSIONES", dataKey: "dimension" },
        { header: "OTROS", dataKey: "otras_caract" },
        { header: "SITUACIÓN", dataKey: "situacion" },
        { header: "ESTADO", dataKey: "estado" },
        { header: "OBSERVACIONES", dataKey: "observacion" },
      ];
      var body = [];

      for (var i = 0; i < me.reporteAsignacion.length; i++) {
        var f_estado = "";
        var f_situacion = "";
        for (var e = 0; e < me.cm.flg_estados.length; e++) {
          f_estado = f_estado + (me.reporteAsignacion[i].flg_estado == me.cm.flg_estados[e].value ? me.cm.flg_estados[e].text : "");
        }
        for (var e = 0; e < me.cm.flg_situaciones.length; e++) {
          f_situacion = f_situacion + (me.reporteAsignacion[i].situacion == me.cm.flg_situaciones[e].value ? me.cm.flg_situaciones[e].text : "");
        }

        body.push({
          item: i + 1,
          codbien: me.reporteAsignacion[i].codbien.length == 12 ? me.reporteAsignacion[i].codbien : me.reporteAsignacion[i].codbienint + "-" + me.reporteAsignacion[i].codinterno,
          tbdescripcion: me.reporteAsignacion[i].tbdescripcion,
          marca: me.reporteAsignacion[i].marca,
          modelo: me.reporteAsignacion[i].modelo,
          tipo: me.reporteAsignacion[i].tipo,
          color: me.reporteAsignacion[i].color,
          serie: me.reporteAsignacion[i].serie,
          dimension: me.reporteAsignacion[i].dimension,
          otras_caract: me.reporteAsignacion[i].otras_caract,
          situacion: f_situacion,
          estado: f_estado,
          observacion: me.reporteAsignacion[i].observacion,
        });
      }

      // Agregar Encabezado: titulo y logo
      const addHeaders = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        for (i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.addImage(imgData, "JPEG", 20, 10, 11, 14); // Logo
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("FORMATO DE FICHA DE LEVANTAMIENTO DE INFORMACIÓN", doc.internal.pageSize.width / 2, 15, { align: "center", });
          doc.setFontSize(11);
          doc.text("INVENTARIO PATRIMONIAL " + me.usuarioState.anoinv, doc.internal.pageSize.width / 2, 19, { align: "center", });
          // doc.text(
          //   "Mobiliario, Equipo y Maquinaria",
          //   doc.internal.pageSize.width / 2,
          //   15,
          //   {
          //     align: "center",
          //   }
          // );
          doc.setFontSize(10);
          doc.text(me.empresaState.nombre, doc.internal.pageSize.width / 2, 23, { align: "center" });
          if (me.ffaltante) { doc.text("BIENES FALTANTES", 250, 23); }

          doc.text("USUARIO:", 40, 30);
          doc.text("PERSONAL INVENTARIADOR:", 170, 30);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.text("Nombres y apellidos: " + me.nompersonal, 40, 35);
          //doc.text("Nº DNI: " + me.nrodocpersonal, 160, 30);
          //doc.text("Correo electrónico: ", 40, 35);
          doc.text("Local: " + me.nomlocal, 40, 40);
          doc.text("Area: " + me.nomarea, 40, 45);
          doc.text("Oficina: " + me.nomoficina, 40, 50);
          //doc.text("Dirección: " + me.direclocal, 40, 50);

          doc.text("Nombres y apellidos: " + me.usuarioState.nomape, 170, 35);
          doc.text(me.empresaState.detalle_inv + " " + me.empresaState.ano_inv, 170, 40);

          doc.setFontSize(6);
          doc.text("Pag. " + i + " de " + pageCount, 250, 13);
          doc.setFont("helvetica", "bold");
          doc.text("Fecha: " + me.formatFecha(me.fechaActual) + "  Ref. " + me.idasignacion, 250, 17);
        }
      };
      // Agregar pie de pagina: numeración
      const addFooters = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        for (i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setDrawColor(0, 0, 0);
          //doc.setLineWidth(0.5)

          var pageWidth = doc.internal.pageSize.width; // Ancho de la hoja

          // Firmas
          var line = 201;
          var linlong = 50;
          var linMargin = 20;

          var startL1 = (pageWidth - linlong * 2 - linMargin) / 2;
          var startL2 = startL1 + linlong + linMargin;
          var startL3 = startL2 + linlong + linMargin;

          doc.line(startL1, line, startL1 + linlong, line);
          doc.text(startL1 + 20, 205, "Usuario");

          doc.line(startL2, line, startL2 + linlong, line);
          doc.text(startL2 + 12, 205, "Personal Inventariador");

          // Consideraciones
          doc.setFont("helvetica", "bold");
          doc.text(10, 170, "CONSIDERACIONES:");
          doc.setFont("helvetica", "normal");
          doc.text(15, 175, "- El usuario declara haber mostrado todos los bienes muebles que se encuentran bajo su responsabilidad y no contar con más bienes muebles materia de inventario.");
          doc.text(15, 180, "- El usuario es responsable de la permanencia y conservación de cada uno de los bienes muebles descritos, recomendánse tomar las precauciones del caso para evitar sustracciones, deterioro, etc.");
          doc.text(15, 185, "- Cualquier necesidad de traslado del bien mueble patrimonial dentro o fuera del local de la Entidad u Organizacion de la Entidad, es previamnete comunicado al encargado de la OCP.");
        }
      };

      var imgData = "data:image/png;base64," + this.empresaState.logo;
      var doc = new jsPDF("l", "mm");

      doc.autoTable({
        theme: "grid",
        columns,
        body,
        margin: { top: 53, bottom: 45, left: 10, right: 10 },
        styles: { cellPadding: 1, overflow: "ellipsize", cellWidth: "wrap" },
        headStyles: {
          fillColor: [46, 79, 120],
          fontSize: 6,
          halign: "center",
          fontStyle: "bold",
        },
        bodyStyles: { textColor: 0, fontSize: 6 },
        columnStyles: {
          item: { cellWidth: 8, halign: "center" },
          codbien: { cellWidth: 20, halign: "center" },
          tbdescripcion: { cellWidth: 35 },
          marca: { cellWidth: 20 },
          modelo: { cellWidth: 20 },
          tipo: { cellWidth: 15 },
          color: { cellWidth: 20 },
          serie: { cellWidth: 20 },
          dimension: { cellWidth: 20 },
          otras_caract: { cellWidth: 30 },
          situacion: { cellWidth: 20 },
          estado: { cellWidth: 16 },
          observacion: { cellWidth: 33 },
        },
      });
      // 515.28 ancho hoja
      addHeaders(doc);
      addFooters(doc);
      // Exportar
      me.stringPdf = doc.output("datauristring");
      me.blobPdf = doc.output("blob");

      // Para visualizar todas las paginas del pdf
      this.srcPdf = pdf.createLoadingTask(this.stringPdf);
      this.srcPdf.promise.then((pdf) => {
        this.numPages = pdf.numPages;
      });
    },
    /* Crear PDF asignacion */

    /* Crear excel stock */
    async crearXLSX() {
      // Estilo para el título principal
      const titleStyle = {
        font: { name: 'Calibri', size: 16, bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true }
      };

      // Estilo para las cabeceras de la tabla de depreciación
      const tableHeaderStyle = {
        font: { name: 'Calibri', bold: true, color: { argb: 'FF000000' } },
        alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC6E0B4' } }, // Color verde claro
      };

      // 1. Crear un nuevo libro y una hoja de cálculo
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Reporte Bienes Asignados');

      // Crear una imagen de base64
      const Base64 = 'data:image/png;base64,' + this.empresaState.logo;
      const logoImage = workbook.addImage({
        base64: Base64,
        extension: 'jpeg',
      });

      // Agregar la imagen a la hoja de cálculo
      worksheet.addImage(logoImage, {
        ext: { width: 50, height: 65 },
      });

      // 2. Definir el ancho de las columnas para que se ajusten al contenido
      worksheet.getColumn('A').width = 6;
      worksheet.getColumn('B').width = 15;
      worksheet.getColumn('C').width = 50;
      worksheet.getColumn('D').width = 35;
      worksheet.getColumn('E').width = 35;
      worksheet.getColumn('F').width = 30;
      worksheet.getColumn('G').width = 35;

      worksheet.getColumn('H').width = 15;
      worksheet.getColumn('I').width = 15;
      worksheet.getColumn('J').width = 15;
      worksheet.getColumn('K').width = 15;
      worksheet.getColumn('L').width = 15;
      worksheet.getColumn('M').width = 15;
      worksheet.getColumn('N').width = 30;
      worksheet.getColumn('O').width = 13;
      worksheet.getColumn('P').width = 12;
      worksheet.getColumn('Q').width = 18;
      worksheet.getColumn('R').width = 35;

      // 2. Añadir el título principal y combinar celdas
      worksheet.addRow(['REPORTE DE BIENES ASIGNADOS \n FECHA ' + this.dateRangeText]);
      worksheet.mergeCells('A1:R1');
      worksheet.getCell('A1').style = titleStyle;
      worksheet.getRow(1).height = 60;

      // 3. Añadir un espacio y la cabecera de la tabla
      const headerRow = worksheet.addRow(['ITEM', 'CÓDIGO PATRIMONIAL', 'DESCRIPCIÓN', 'LOCALES', 'AREAS', 'OFICINAS', 'PERSONAL', 'MARCA', 'MODELO', 'TIPO', 'COLOR', 'SERIE', 'DIMENSIÓN', 'OTROS', 'ESTADO', 'USUARIO', 'FECHA', 'OBSERVACIÓN']);
      headerRow.eachCell(cell => {
        headerRow.eachCell((cell, colNumber) => {
          cell.style = {
            ...tableHeaderStyle,
            fill: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {
                argb: 'FFC6E0B4' // Verde claro
              }
            }
          };
        });
      });

      // 4. Añadir los datos de la tabla
      let itemCounter = 1;

      this.reporteAsignacion.forEach(rowData => {
        //var t_cta = "";
        //var f_condicion = "";
        var f_estado = "";
        //var f_situacion = "";

        /* for (var t = 0; t < this.cm.tipo_ctas.length; t++) {
          t_cta = t_cta + (rowData.tipo_cta == this.cm.tipo_ctas[t].value ? this.cm.tipo_ctas[t].text : "");
        }

        for (var c = 0; c < this.cm.flg_conds.length; c++) {
          f_condicion = f_condicion + (rowData.flg_cond == this.cm.flg_conds[c].value ? this.cm.flg_conds[c].text : "");
        } */

        for (var e = 0; e < this.cm.flg_estados.length; e++) {
          f_estado = f_estado + (rowData.flg_estado == this.cm.flg_estados[e].value ? this.cm.flg_estados[e].text : "");
        }

        /* for (var e = 0; e < this.cm.flg_situaciones.length; e++) {
          f_situacion = f_situacion + (rowData.situacion == this.cm.flg_situaciones[e].value ? this.cm.flg_situaciones[e].text : "");
        } */
        const row = worksheet.addRow([
          itemCounter++,
          rowData.codbien.length == '12' ? rowData.codbien : rowData.codbienint + '-' + rowData.codinterno,
          rowData.tbdescripcion,
          rowData.nomlocales,
          rowData.nomareas,
          rowData.nomoficinas,
          rowData.pnombres,

          rowData.marca,
          rowData.modelo,
          rowData.tipo,
          rowData.color,
          rowData.serie,
          rowData.dimension,
          rowData.otras_caract,
          f_estado,
          rowData.nickname,
          moment(rowData.fec_act).format('DD/MM/YYYY HH:mm:ss'),
          rowData.observacion
        ]);

        // Aplicar estilos y bordes
        function aplicarBorde(row, startCol, endCol, colorARGB) {
          for (let col = startCol; col <= endCol; col++) {
            const cell = row.getCell(col);
            cell.border = {
              top: { style: 'thin', color: { argb: colorARGB } },
              left: { style: 'thin', color: { argb: colorARGB } },
              bottom: { style: 'thin', color: { argb: colorARGB } },
              right: { style: 'thin', color: { argb: colorARGB } },
            };
          }
        }
        aplicarBorde(row, 1, 18, 'FFC6E0B4');    // Bordes verde claro en columnas 1 a mas

        // Centrar la celda
        [1, 2, 16, 17].forEach(col => {
          row.getCell(col).alignment = { horizontal: 'center' };
        });

        // Formato y estilo para columnas
        [30, 31].forEach(col => {
          const cell = row.getCell(col);
          cell.numFmt = '#,##0.00'; // incluye símbolo de soles
          cell.alignment = { horizontal: 'right' };
          cell.font = { name: 'Calibri', size: 11 };
        });
      });

      // Ocultar las líneas de división de la hoja de cálculo
      worksheet.views = [
        {
          showGridLines: false
        }
      ];

      // 7. Generar el archivo y descargarlo
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Reporte Bienes Asignados.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    /* Fin Crear excel stock */
  },
};
</script>